var def = require('./$').setDesc
  , has = require('./$.has')
  , TAG = require('./$.wks')('toStringTag');

module.exports = function(it, tag, stat){
  if(it && !has(it = stat ? it : it.prototype, TAG))def(it, TAG, {configurable: true, value: tag});
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-api-middleware/node_modules/core-js/library/modules/$.set-to-string-tag.js
// module id = 169
// module chunks = 1 2 3